import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { LaborCostChartIn } from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostChartIn.ts";
import {
  getLaborCostChartData,
  laborCostChartDataQueryKey,
} from "@/pages/human-resources/time-management/endpoints/LaborCostChartDataEndpoint.ts";
import type { LaborCostChartData } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartData.ts";

export function useReadLaborCostChartData(
  params: LaborCostChartIn,
  enabled: boolean,
): UseQueryResult<LaborCostChartData> {
  return useQuery<LaborCostChartData>({
    queryKey: laborCostChartDataQueryKey.forSiteDateModeAndService(params),
    queryFn: async () => getLaborCostChartData(params),
    enabled,
  });
}
